import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";

/**
 * WalkinsApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/walkinsApi/walkinsApi.service.js.
 *
 * Two sub-namespaces preserved 1:1 with the legacy:
 *   apiService.walkins.orders.create(props)
 *   apiService.walkins.sources.detail()
 */
const WALKIN_BASE = "/v1/api/walkin";
const WALKIN_ORDERS_BASE = `${WALKIN_BASE}/orders`;
const WALKIN_SOURCES_BASE = `${WALKIN_ORDERS_BASE}/sourcenames`;

interface WalkinOrderCreateProps {
  eventId: number | string;
  contactFirstName: string;
  contactLastName: string;
  sourceName: string;
  notes?: string;
  items: unknown[];
}

@Injectable({ providedIn: "root" })
export class WalkinsApiService {
  private readonly http = inject(HttpClient);

  readonly orders = {
    create: (props: WalkinOrderCreateProps): Promise<AjsResponse<unknown>> =>
      wrapAjs(
        this.http.post<unknown>(WALKIN_ORDERS_BASE, {
          eventId: props.eventId,
          contactFirstName: props.contactFirstName,
          contactLastName: props.contactLastName,
          sourceName: props.sourceName,
          notes: props.notes,
          items: props.items,
        }),
      ),
  };

  readonly sources = {
    detail: (): Promise<AjsResponse<unknown>> =>
      wrapAjs(this.http.get<unknown>(WALKIN_SOURCES_BASE)),
  };
}
